var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import { ContextTabIndexState } from './Tabs';
const TabPanelSC = styled.div `
  padding: 0;
  margin: 0;
`;
const TabPanel = (props) => {
    const { children, forwardedRef, className: classNameProp, index } = props, others = __rest(props, ["children", "forwardedRef", "className", "index"]);
    const { activeIndex } = React.useContext(ContextTabIndexState);
    const isActive = activeIndex === index;
    return isActive ? (React.createElement(TabPanelSC, Object.assign({ ref: forwardedRef, className: clsx(classNameProp, '_ndsTabPanel', {
            '_ndsTabPanel--active': activeIndex === index
        }), "data-index": index, role: "tabpanel" }, others), children)) : null;
};
TabPanel.propTypes = {
    children: PropTypes.node,
    forwardedRef: PropTypes.any,
    className: PropTypes.string,
    index: PropTypes.number
};
TabPanel.defaultProps = {
    children: null,
    forwardedRef: React.createRef(),
    className: undefined,
    index: 0
};
export default withForwardedRef(TabPanel);
//# sourceMappingURL=TabPanel.js.map